import OffenseSearch from '../models/offenseSearch';
import OffenseRecord from '../models/offenseRecord';

export default class Offense {

  constructor(offenseSearch: OffenseSearch, offenseRecords: OffenseRecord[]) {
    this.offenseSearch = offenseSearch;
    this.offenseRecords = offenseRecords;
  }

  offenseSearch: OffenseSearch;
  offenseRecords: OffenseRecord[];
}



// WEBPACK FOOTER //
// ./src/models/offense.ts